/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MessageCategory } from './MessageCategory';
import {
    MessageCategoryFromJSON,
    MessageCategoryFromJSONTyped,
    MessageCategoryToJSON,
} from './MessageCategory';
import type { MessageDeliveryType } from './MessageDeliveryType';
import {
    MessageDeliveryTypeFromJSON,
    MessageDeliveryTypeFromJSONTyped,
    MessageDeliveryTypeToJSON,
} from './MessageDeliveryType';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    senderId?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    messageId?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    content?: string;
    /**
     * 
     * @type {MessageDeliveryType}
     * @memberof Message
     */
    deliveryType?: MessageDeliveryType;
    /**
     * 
     * @type {MessageCategory}
     * @memberof Message
     */
    category?: MessageCategory;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    readonly organisationId?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    readonly organisationName?: string;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    updated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    expiration?: Date;
}

/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'senderId': !exists(json, 'senderId') ? undefined : json['senderId'],
        'messageId': !exists(json, 'messageId') ? undefined : json['messageId'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'deliveryType': !exists(json, 'deliveryType') ? undefined : MessageDeliveryTypeFromJSON(json['deliveryType']),
        'category': !exists(json, 'category') ? undefined : MessageCategoryFromJSON(json['category']),
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'organisationName': !exists(json, 'organisationName') ? undefined : json['organisationName'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'expiration': !exists(json, 'expiration') ? undefined : (new Date(json['expiration'])),
    };
}

export function MessageToJSON(value?: Message | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'senderId': value.senderId,
        'messageId': value.messageId,
        'subject': value.subject,
        'content': value.content,
        'deliveryType': MessageDeliveryTypeToJSON(value.deliveryType),
        'category': MessageCategoryToJSON(value.category),
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'expiration': value.expiration === undefined ? undefined : (value.expiration.toISOString()),
    };
}

